const api = {
  adid: 'adid'
}

export const adType = {
  payment: 'payment'
}

export function setAddressId (adid) {
  sessionStorage.setItem(api.adid, adid)
}

export function getAddressId () {
  return sessionStorage.getItem(api.adid)
}

